import { gql } from "@apollo/client";

export const usageListQuery = gql`
    query UsageList(
        $articleDescription: String
        $articleNumber: String
        $modelSearch: String
        $filter: CompatibleArticlesFilter
        $sort: [CompatibleArticleSort!]
        $offset: Int!
        $limit: Int!
        $languageCode: String
    ) {
        data: compatibleArticles(
            articleNameSearch: $articleDescription
            articleNumberSearch: $articleNumber
            modelSearch: $modelSearch
            filter: $filter
            sort: $sort
            offset: $offset
            limit: $limit
            languageCode: $languageCode
        ) {
            items: nodes {
                modelId
                modelYear
                modelDescription
                modelSpecification
                componentGroupDescription
                componentGroupId
                componentGroupType
                articleName
                articleNumber
            }
            totalItems: totalCount
        }
    }
`;
